import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MaxInvestmentAmountResolver } from "../../../../../resolvers/maxInvestmentAmount.resolver";
import { FlexInvestmentAmountResolver } from "../../../../../resolvers/flexInvestmentAmount.resolver";
import { LenderBasicInfoResolver } from "../../../../../resolvers/lender-info.resolver";
import { ProductResolver } from "../../../../../resolvers/product.resolver";
import { PortfolioCreationFailureComponent } from "./portfolio-creation-failure/portfolio-creation-failure.component";
import { PortfolioCreationSuccessfulComponent } from "./portfolio-creation-successful/portfolio-creation-successful.component";
import { PortfolioCreationComponent } from "./portfolio-creation.component";

const routes: Routes = [
    {
        path: '',
        redirectTo: 'portfolio-creation'
    },
    {
        path: 'portfolio-creation',
        component: PortfolioCreationComponent,
        resolve: {
            subProduct: ProductResolver,
            lenderBasicInfo: LenderBasicInfoResolver,
            flexInvestmentAmount: FlexInvestmentAmountResolver,
            maxInvestmentAmount: MaxInvestmentAmountResolver
        }
    },
    {
        path: 'successful',
        component: PortfolioCreationSuccessfulComponent,
    },
    {
        path: 'failure',
        component: PortfolioCreationFailureComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PortfolioCreationRoutingModule {}